import script from "./ViewAppraisalsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ViewAppraisalsPage.vue?vue&type=script&setup=true&lang=js"

import "./ViewAppraisalsPage.vue?vue&type=style&index=0&id=afb0c74c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-afb0c74c"]])

export default __exports__